import { selectedShout, setSelectedShout } from "../client";
import { switchPanTilt } from "../dom/switchPanTilt";
import { getEffect } from "../utils/effectsIni";

/**
 * Resets the IC parameters for the player to enter a new chat message.
 * This should only be called when the player's previous chat message
 * was successfully sent/presented.
 */
export function resetICParams() {
  (<HTMLInputElement>document.getElementById("client_inputbox")).value = "";
  document.getElementById("button_flash")!.classList.remove("dark");
  document.getElementById("button_shake")!.classList.remove("dark");

  // webCOA: "Sticky" keeps the Preanimation checkbox on across sends, so
  // users animating every line don't have to re-tick it each time.
  const sticky = <HTMLInputElement>document.getElementById("sticky_preanim");
  if (!sticky || !sticky.checked) {
    (<HTMLInputElement>document.getElementById("sendpreanim")).checked = false;
  }
  (<HTMLInputElement>document.getElementById("sendsfx")).checked = false;

  // Slide is per-message by default: uncheck it after a send (and disable
  // the smooth-transition rendering) unless "Sticky" slide is on.
  const stickySlide = <HTMLInputElement>document.getElementById("sticky_slide");
  const slide = <HTMLInputElement>document.getElementById("client_pantilt");
  if (slide && slide.checked && (!stickySlide || !stickySlide.checked)) {
    slide.checked = false;
    switchPanTilt();
  }

  if (selectedShout) {
    document
      .getElementById(`button_${selectedShout}`)!
      .classList.remove("dark");
    setSelectedShout(0);
  }

  // Effects are per-message in AO2: after sending, the dropdown snaps back to
  // "None". Two things keep it selected instead:
  //   - the "Sticky > Effects" toggle (AO2's stickyeffects option), which
  //     keeps ANY effect selected so it is re-sent every message; and
  //   - the effect's own sticky flag in effects.ini, which does the same for
  //     just that effect (gallerybg, lights, defensebar, dramathink...).
  // Re-sending is what makes those looping backdrops appear to persist; the
  // effect layer itself is still cleared and replayed each message, as AO2
  // does it. The toggle is off by default, so the AO2 default applies.
  const effect_select = <HTMLSelectElement>(
    document.getElementById("effect_select")
  );
  const stickyEffects = <HTMLInputElement>(
    document.getElementById("sticky_effects")
  );
  if (
    effect_select &&
    effect_select.selectedIndex > 0 &&
    (!stickyEffects || !stickyEffects.checked)
  ) {
    const effectName = effect_select.value.split("|")[0];
    const props = getEffect(effectName);
    if (!props || !props.sticky) {
      effect_select.selectedIndex = 0;
    }
  }
}
